'use strict';

var NetSpillRateController = function NetSpillRateController($scope, netSpillRateDataService, constantService, configurationService) {
  $scope.legendLabels = [{
    label: 'Actual Net Spill Rate',
    styleClass: 'actualRate-bar'
  }, {
    label: 'Optimal Net Spill Rate',
    styleClass: 'optimalRate-bar'
  }];
  $scope.avgFareLabel = 'Avg. Fare (' + configurationService.getCurrencySymbol() + ')';
  netSpillRateDataService.getData().then(function (data) {
    $scope.data = data;
  });
};
NetSpillRateController.$inject = ['$scope', 'NetSpillRateDataService', 'DataRetrieverConstantsService', 'ConfigurationService'];
module.exports = NetSpillRateController;